import { useState } from "react";
import { Card, PageHeader, Btn } from "../../components/shared/UIComponents";

export default function DataLocking() {
  const [auditLock, setAuditLock] = useState(true);
  const [dataLock, setDataLock] = useState(false);
  return (
    <Card>
      <PageHeader title="Financial Year Locking" />
      <div style={{ padding: 32 }}>
        <p style={{ color: "#546e7a", fontWeight: 600, marginBottom: 20, fontSize: 14 }}>Select For Locking for FY 2025-2026</p>
        {[["Data Lock", dataLock, setDataLock], ["Audit Lock", auditLock, setAuditLock]].map(([label, val, set]) => (
          <label key={label} style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer", fontSize: 14, color: "#263238", marginBottom: 14 }}>
            <input type="checkbox" checked={val} onChange={e => set(e.target.checked)} style={{ width: 18, height: 18, accentColor: "#1565c0" }} />
            {label}
          </label>
        ))}
        <div style={{ marginTop: 20 }}><Btn>Save</Btn></div>
      </div>
    </Card>
  );
}
